// extracted by mini-css-extract-plugin
module.exports = {"makerGreen":"#385461","makerWhite":"white","footer":"footer_footer__1lZIc","title":"footer_title__pkoUs"};